import * as THREE from "three";
import type { EnemyView } from "./enemyView";

/**
 * Where weapons aim at a flying enemy: the middle of its drawn body. A flyer's root rides the ground under it (the
 * shadow and the target ring sit there) while its body hovers at its flying height (enemyFeel.ts: `body.position.y`,
 * bob included), so the rounds, bolts and arcs that aimed at the root plus a little lift flew to the grass under it.
 */
export const AIR_AIM_BODY_SHARE = 0.45;

/** The point a weapon aims at on flying view `v` (into `out`), or null for a ground unit (its aim stays at its feet). */
export function airAimPoint(v: Pick<EnemyView, "air" | "root" | "body" | "hq" | "headNow" | "headY">, out: THREE.Vector3): THREE.Vector3 | null {
  if (!v.air) return null;
  const head = v.hq ? v.headNow : v.headY;
  return out.set(v.root.position.x + v.body.position.x, v.root.position.y + v.body.position.y + head * AIR_AIM_BODY_SHARE, v.root.position.z + v.body.position.z);
}
